import React from 'react'
import { observer } from 'mobx-react-lite'
import { CardsFilter } from 'shared/ui'
import { usePowerDialerViewContext } from 'pages/powerDialer/pages/view/context/powerDialerViewContext'
import styles from './styles.module.scss'

export const PowerDialerContactsFilter = observer(() => {
  const { powerDialerContactsStore } = usePowerDialerViewContext()

  if (!powerDialerContactsStore) return null

  const { filters, selectedFilterKey, setFilter } = powerDialerContactsStore

  return (
    <CardsFilter
      items={filters}
      activeKey={selectedFilterKey}
      onActiveFilter={setFilter}
      wrapperClassName={styles.filter}
    />
  )
})
